import { useEffect, useState } from "react";

import { adminRequests } from "@/api/(requests)/admin";

export const useProviderInactivationOptions = () => {
  const [options, setOptions] = useState([]);
  const getInactivationOptions = async () => {
    const response = await adminRequests.get_provider_inactivation_options();

    setOptions(response);
  };

  useEffect(() => {
    getInactivationOptions();
  }, []);

  const transformToSelectOptions = () => {
    return options.map((option) => {
      return {
        label: option.reason,
        value: option.reason_id,
      };
    });
  };

  return {
    selectableOptions: transformToSelectOptions(options),
  };
};
